import { type ReadonlyVec2, vec2, vec3 } from 'gl-matrix';

import type { TextAlignment } from '@canvas/adf';

import { DEFAULT_FONT_SCALE, SpacingType } from '../text';

export enum TextLevel {
  Mixed = -1,
  Normal = 0,
  Heading1 = 1,
  Heading2 = 2,
  Heading3 = 3,
  Heading4 = 4,
  Heading5 = 5,
  Heading6 = 6,
}

export const TEXT_MIN_WIDTH = 18; // minimum width to contain a wide character of paragraph-sized text. This MUST NOT be larger than textBoardSize[0]

export const DEFAULT_TEXT_BOX_PADDING = 8;

export const minTextBoardContentSize: ReadonlyVec2 = vec2.fromValues(TEXT_MIN_WIDTH, 22);
export const minTextBoardSize: ReadonlyVec2 = vec2.fromValues(
  minTextBoardContentSize[0] + DEFAULT_TEXT_BOX_PADDING * 2,
  minTextBoardContentSize[1] + DEFAULT_TEXT_BOX_PADDING * 2
);
export const textBoardSize = vec2.fromValues(
  // The final/rendered text width gets measured to 68 because of 'Add text' showing up in the editor. This isn't accounted for in the board's size
  76,
  minTextBoardSize[1]
);

export const TEXT_BOX_PLACEHOLDER_PROPERTIES = {
  alignment: 'left' as const,
  verticalAlignment: 'middle' as const,
  width: null,
  fontScale: DEFAULT_FONT_SCALE,
  padding: DEFAULT_TEXT_BOX_PADDING,
  spacing: SpacingType.default,
};

export const textColor = {
  /**
   * HEX: #172b4d
   * RGB: 23, 43, 77
   * CLIPSPACE: RGB / 255
   */
  default: vec3.fromValues(0.09, 0.17, 0.3),
  /**
   * HEX: #42526E
   * RGB: 66, 82, 110
   * CLIPSPACE: RGB / 255
   */
  mention: vec3.fromValues(0.26, 0.32, 0.43),
};

export const defaultTextAlignment = 'left' as TextAlignment;

/**
 * When we paste text (not the whiteboard element), we create a text entity, but it has
 * unrestricted horizontal growth. This means that the text entity can grow infinitely,
 * so we set a maximum width of 650.
 */
export const MAX_PASTED_TEXT_WIDTH = 650;
